import React, { useEffect, useState, useCallback } from "react";
import SettingsService from "services/SettingsService";
import DataTreatmentPolicyModal from "./DataTreatmentPolicyModal";
import { handleErrors } from "jsx/components/CitoPlus/components/ErrorHandlingComponent";

/**
 * Gatekeeper que muestra el modal de Política de Tratamiento de Datos
 * para usuarios ADMIN después del login.
 * - Si la política no aplica (texto vacío), no bloquea.
 * - Si aplica y no está aceptada, muestra el modal y bloquea el contenido.
 */
const DataTreatmentPolicyGate = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const isAdmin = useCallback(() => {
    const raw = localStorage.getItem("userDetails");
    if (!raw) return false;
    try {
      const parsed = JSON.parse(raw);
      return parsed?.user?.tipo === "ADMIN";
    } catch (e) {
      return false;
    }
  }, []);

  useEffect(() => {
    const checkPolicy = async () => {
      if (!isAdmin()) {
        setLoading(false);
        return;
      }
      try {
        const data = await SettingsService.getDataPolicy();
        const applies = Boolean(data.applies);
        const accepted = Boolean(data.accepted);
        setShowModal(applies && !accepted);
      } catch (error) {
        handleErrors(error);
        // Fallback seguro: no bloquear si falla la carga
        setShowModal(false);
      } finally {
        setLoading(false);
      }
    };
    checkPolicy();
  }, [isAdmin]);

  const handleAccepted = () => {
    setShowModal(false);
  };

  if (loading) {
    return null;
  }

  return (
    <>
      <DataTreatmentPolicyModal show={showModal} onAccepted={handleAccepted} />
      {!showModal && children}
    </>
  );
};

export default DataTreatmentPolicyGate;
